import { Chain } from '../types';

export const isSignetPremiumOnly = (chain: Chain) => {
  return chain.signets && chain?.signets?.length > 0
    ? chain.signets.every(signet => signet.premiumOnly)
    : false;
};
